import { mapGetters } from "vuex";
const customerServiceMixins = {
  computed: {
    ...mapGetters({
      recognizedUserEmail: "email"
    })
  }
};

export default customerServiceMixins;
